var prepareDefaultHeadTags = function (title, description) {
    return [
        {
            "tag": "title",
            "attributes": {},
            "value": title
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": title
            }
        },
        {
            "tag": "meta",
            "attributes": {"name": "description", "content": description}
        },
        {
            "tag": "meta",
            "attributes": {"property": "og:description", "content": description}
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {"property": "og:site_name", "content": "Harri"}
        }
    ];
};

var wpRoutes = {};
var header = {};

header = {
    'default': [
        {
            'id': 18007,
            'url': '/platform/',
            'title': 'Platform: Products & Solutions',
            'menu_order': 1,
            'object': 'page',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 4186,
                    'url': '/pre-hire/',
                    'title': 'Talent Acquisition',
                    'menu_order': 2,
                    'object': 'page',
                    'menu_item_parent': '18007',
                    'description': 'Talent solutions to source, attract, and hire your teams.',
                    'children': [
                        {
                            'id': 4189,
                            'url': '/pre-hire/talent-attraction/',
                            'title': 'Talent Attraction',
                            'menu_order': 3,
                            'object': 'page',
                            'menu_item_parent': '4186',
                            'description': ''
                        },
                        {
                            'id': 4188,
                            'url': '/pre-hire/applicant-tracking/',
                            'title': 'Applicant Tracking',
                            'menu_order': 4,
                            'object': 'page',
                            'menu_item_parent': '4186',
                            'description': ''
                        },
                        {
                            'id': 4187,
                            'url': '/pre-hire/onboarding/',
                            'title': 'Onboarding',
                            'menu_order': 5,
                            'object': 'page',
                            'menu_item_parent': '4186',
                            'description': ''
                        },
                        {
                            'id': 16545,
                            'url': '/carri-chat-and-apply/',
                            'title': 'Carri',
                            'menu_order': 6,
                            'object': 'page',
                            'menu_item_parent': '4186',
                            'description': ''
                        }
                    ]
                },
                {
                    'id': 4190,
                    'url': '/post-hire/',
                    'title': 'Workforce Management',
                    'menu_order': 7,
                    'object': 'page',
                    'menu_item_parent': '18007',
                    'description': 'Workforce management solutions to schedule, engage, and analyze your teams.',
                    'children': [
                        {
                            'id': 4193,
                            'url': '/post-hire/scheduling/',
                            'title': 'Scheduling',
                            'menu_order': 8,
                            'object': 'page',
                            'menu_item_parent': '4190',
                            'description': ''
                        },
                        {
                            'id': 4192,
                            'url': '/post-hire/time-attendance/',
                            'title': 'Time & Attendance',
                            'menu_order': 9,
                            'object': 'page',
                            'menu_item_parent': '4190',
                            'description': ''
                        },
                        {
                            'id': 18666,
                            'url': '/engagement/',
                            'title': 'Engagement',
                            'menu_order': 10,
                            'object': 'page',
                            'menu_item_parent': '4190',
                            'description': ''
                        },
                        {
                            'id': 4191,
                            'url': '/post-hire/communications/',
                            'title': 'Communications',
                            'menu_order': 11,
                            'object': 'page',
                            'menu_item_parent': '4190',
                            'description': ''
                        }
                    ]
                },
                {
                    'id': 4194,
                    'url': '/insights-analytics/',
                    'title': 'Harri IQ',
                    'menu_order': 12,
                    'object': 'page',
                    'menu_item_parent': '18007',
                    'description': ''
                }
            ]
        },
        {
            'id': 14188,
            'url': '/compliance/',
            'title': 'Integrated Compliance',
            'menu_order': 13,
            'object': 'page',
            'menu_item_parent': '0',
            'description': ''
        },
        {
            'id': 14873,
            'url': 'http://resources.harri.com',
            'title': 'Resources',
            'menu_order': 14,
            'object': 'custom',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 18354,
                    'url': 'https://resources.harri.com/events-webinars/',
                    'title': 'Events & Webinars',
                    'menu_order': 15,
                    'object': 'custom',
                    'menu_item_parent': '14873',
                    'description': ''
                },
                {
                    'id': 18306,
                    'url': 'https://resources.harri.com/category/case-studies/',
                    'title': 'Client Stories',
                    'menu_order': 16,
                    'object': 'custom',
                    'menu_item_parent': '14873',
                    'description': ''
                },
                {
                    'id': 18099,
                    'url': 'https://resources.harri.com/guides-ebooks/',
                    'title': 'Guides & Ebooks',
                    'menu_order': 17,
                    'object': 'custom',
                    'menu_item_parent': '14873',
                    'description': ''
                },
                {
                    'id': 18098,
                    'url': 'https://resources.harri.com/category/blog/',
                    'title': 'Blog',
                    'menu_order': 18,
                    'object': 'custom',
                    'menu_item_parent': '14873',
                    'description': ''
                },
                {
                    'id': 14692,
                    'url': '/harri-insider/',
                    'title': 'Harri Insider',
                    'menu_order': 19,
                    'object': 'page',
                    'menu_item_parent': '14873',
                    'description': ''
                }
            ]
        },
        {
            'id': 14690,
            'url': '/about-us/',
            'title': 'About Us',
            'menu_order': 20,
            'object': 'page',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 14696,
                    'url': '/why-harri-platform/',
                    'title': 'Why Harri',
                    'menu_order': 21,
                    'object': 'page',
                    'menu_item_parent': '14690',
                    'description': ''
                },
                {
                    'id': 17696,
                    'url': '/careers/',
                    'title': 'Join the Team',
                    'menu_order': 22,
                    'object': 'page',
                    'menu_item_parent': '14690',
                    'description': ''
                },
                {
                    'id': 14694,
                    'url': '/partners/',
                    'title': 'Our Partners',
                    'menu_order': 23,
                    'object': 'page',
                    'menu_item_parent': '14690',
                    'description': ''
                }
            ]
        }
    ],
    'uk': [
        {
            'id': 11098,
            'url': '/platform/',
            'title': 'Products & Solutions',
            'menu_order': 1,
            'object': 'page',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 7148,
                    'url': '/pre-hire/',
                    'title': 'Talent Acquisition',
                    'menu_order': 2,
                    'object': 'page',
                    'menu_item_parent': '11098',
                    'description': 'Talent solutions to source, attract, and hire your teams.',
                    'children': [
                        {
                            'id': 7149,
                            'url': '/pre-hire/talent-attraction/',
                            'title': 'Talent Attraction',
                            'menu_order': 3,
                            'object': 'page',
                            'menu_item_parent': '7148',
                            'description': ''
                        },
                        {
                            'id': 7150,
                            'url': '/pre-hire/applicant-tracking/',
                            'title': 'Applicant Tracking',
                            'menu_order': 4,
                            'object': 'page',
                            'menu_item_parent': '7148',
                            'description': ''
                        },
                        {
                            'id': 7151,
                            'url': '/pre-hire/onboarding/',
                            'title': 'Employee Onboarding Software for Hospitality',
                            'menu_order': 5,
                            'object': 'page',
                            'menu_item_parent': '7148',
                            'description': ''
                        },
                        {
                            'id': 10685,
                            'url': '/carri-chat-and-apply/',
                            'title': 'Carri',
                            'menu_order': 6,
                            'object': 'page',
                            'menu_item_parent': '7148',
                            'description': ''
                        }
                    ]
                },
                {
                    'id': 7152,
                    'url': '/post-hire/',
                    'title': 'Workforce Management',
                    'menu_order': 7,
                    'object': 'page',
                    'menu_item_parent': '11098',
                    'description': 'Workforce management solutions to schedule, engage, and analyse your teams.',
                    'children': [
                        {
                            'id': 7153,
                            'url': '/post-hire/scheduling/',
                            'title': 'Scheduling',
                            'menu_order': 8,
                            'object': 'page',
                            'menu_item_parent': '7152',
                            'description': ''
                        },
                        {
                            'id': 9699,
                            'url': '/payroll/',
                            'title': 'Payroll',
                            'menu_order': 9,
                            'object': 'page',
                            'menu_item_parent': '7152',
                            'description': ''
                        },
                        {
                            'id': 7154,
                            'url': '/post-hire/time-attendance/',
                            'title': 'Time & Attendance',
                            'menu_order': 10,
                            'object': 'page',
                            'menu_item_parent': '7152',
                            'description': ''
                        },
                        {
                            'id': 11585,
                            'url': '/engagement/',
                            'title': 'Engagement',
                            'menu_order': 11,
                            'object': 'page',
                            'menu_item_parent': '7152',
                            'description': ''
                        },
                        {
                            'id': 7155,
                            'url': '/post-hire/communications/',
                            'title': 'Communications',
                            'menu_order': 12,
                            'object': 'page',
                            'menu_item_parent': '7152',
                            'description': ''
                        }
                    ]
                },
                {
                    'id': 7156,
                    'url': '/insights-analytics/',
                    'title': 'Harri IQ',
                    'menu_order': 13,
                    'object': 'page',
                    'menu_item_parent': '11098',
                    'description': ''
                }
            ]
        },
        {
            'id': 7158,
            'url': '/partners/',
            'title': 'Partners',
            'menu_order': 14,
            'object': 'page',
            'menu_item_parent': '0',
            'description': ''
        },
        {
            'id': 8775,
            'url': 'https://resources.harri.com/',
            'title': 'Resources',
            'menu_order': 15,
            'object': 'custom',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 11286,
                    'url': 'https://resources.harri.com/events-webinars/',
                    'title': 'Events & Webinars',
                    'menu_order': 16,
                    'object': 'custom',
                    'menu_item_parent': '8775',
                    'description': ''
                },
                {
                    'id': 11255,
                    'url': 'https://resources.harri.com/category/case-studies/',
                    'title': 'Client Stories',
                    'menu_order': 17,
                    'object': 'custom',
                    'menu_item_parent': '8775',
                    'description': ''
                },
                {
                    'id': 11123,
                    'url': 'https://resources.harri.com/guides-ebooks/',
                    'title': 'Guides & Ebooks',
                    'menu_order': 18,
                    'object': 'custom',
                    'menu_item_parent': '8775',
                    'description': ''
                },
                {
                    'id': 11122,
                    'url': 'https://resources.harri.com/category/blog/',
                    'title': 'Blog',
                    'menu_order': 19,
                    'object': 'custom',
                    'menu_item_parent': '8775',
                    'description': ''
                },
                {
                    'id': 11124,
                    'url': '/harri-insider/',
                    'title': 'Harri Insider',
                    'menu_order': 20,
                    'object': 'page',
                    'menu_item_parent': '8775',
                    'description': ''
                }
            ]
        },
        {
            'id': 7159,
            'url': '/about-us/',
            'title': 'About Us',
            'menu_order': 21,
            'object': 'page',
            'menu_item_parent': '0',
            'description': '',
            'children': [
                {
                    'id': 10830,
                    'url': '/careers',
                    'title': 'Join the Team',
                    'menu_order': 22,
                    'object': 'custom',
                    'menu_item_parent': '7159',
                    'description': ''
                }
            ]
        }
    ]
};


wpRoutes["/post-jobs?activePackages"] = {
    "enableUTM": true,
    "showGlobalSearch": false,
    "disableSSR": true,
    "name": "pricing",
    "type": "backend-frontend",
    "templateUrl": "../modules/billing/views/pricing.html",
    "data": [
        {"type": "api", "link": "payment/get_packages", 'id': 'packages'},
        {"type": "api", "link": "payment/get_subscription_packages", 'id': 'subscriptionPackages'}
    ],
    "dataMappingCallback": function (data, routeOptions, publicFunctions) {

        if (typeof (_) != 'undefined') {
            var subscription = _.map(data.subscriptionPackages.data, function (obj, key) {
                var data = obj;
                data.Package.PackageSubscription = _.groupBy(obj.Package.PackageSubscription, 'type');
                return data;
            });

            data.subscriptionPackages.data = subscription;
        }

        return {
            data: data,
            wpDynamicHeaderMenu: header
        };
    },
    "route_styles": {
        framework: "bootstrap_v4"
    },
    "headTags": prepareDefaultHeadTags(
        "Simple Pricing, Designed To Fit Your Needs",
        "Find the best fit for your team and start hiring top talent."
    )
};

wpRoutes["/workforce-compliance"] = {
    "enableUTM": true,
    "showGlobalSearch": false,
    "disableSSR": true,
    "name": "lms_compliance_training",
    "type": "backend-frontend",
    "route_styles": {
        framework: "bootstrap_v4"
    },
    "templateUrl": "../modules/landing_pages/views/2018/lms-landing-page.html",
    "controller": "LandingPageController",
    "data": [
        {"type": "api", "link": "payment/get_packages?mode=LMS", 'id': 'packages'},
    ],
    "headTags": prepareDefaultHeadTags(
        "Workforce Training Platform | Happiness in Hospitality - HARRI",
        ""
    ),
    "dataMappingCallback": function (data, routeOptions, publicFunctions) {
        return {
            data: data,
            wpDynamicHeaderMenu: header
        };
    }
};


wpRoutes['/msa-copy'] = {
    "name": "wp__msa_copy",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_msa-copy_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_msa-copy_",
            "UK:landing_uk:_msa-copy_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_msa-copy_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/msa-copy"
            }
        }
    ]
};
wpRoutes['/msa'] = {
    "name": "wp__msa",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_msa_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_msa_",
            "UK:landing_uk:_msa_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_msa_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/msa"
            }
        }
    ]
};
wpRoutes['/facial-recognition-consent'] = {
    "name": "wp__facial_recognition_consent",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_facial-recognition-consent_.html",
        "uk": "../wp-pages/pages/compiled/uk/_facial-recognition-consent_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_facial-recognition-consent_",
            "UK:landing_uk:_facial-recognition-consent_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_facial-recognition-consent_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_facial-recognition-consent_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/facial-recognition-consent"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "robots",
                "content": "noindex"
            }
        }
    ]
};
wpRoutes['/engagement'] = {
    "name": "wp__engagement",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_engagement_.html",
        "uk": "../wp-pages/pages/compiled/uk/_engagement_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_engagement_",
            "UK:landing_uk:_engagement_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_engagement_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_engagement_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Employee Engagement and Workforce Retention Software for Hospitality | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Employee Engagement and Workforce Retention Software for Hospitality | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Discover Harri Engage: our innovative employee engagement software solution designed to enhance satisfaction and retention, especially for frontline hospitality teams."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Discover Harri Engage: our innovative employee engagement software solution designed to enhance satisfaction and retention, especially for frontline hospitality teams."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20250506154556/assets/8d22aa93f0bbdca3ed87ea94a1339a86.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/engagement"
            }
        }
    ]
};
wpRoutes['/dmca-policy'] = {
    "name": "wp__dmca_policy",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_dmca-policy_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_dmca-policy_",
            "UK:landing_uk:_dmca-policy_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_dmca-policy_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "DMCA Policy | Harri LLC"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "DMCA Policy | Harri LLC"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "We comply with the Digital Millennium Copyright Act and provide a method for copyright owners to communicate information about alleged infringements to us, and for us to inform our users about them."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "We comply with the Digital Millennium Copyright Act and provide a method for copyright owners to communicate information about alleged infringements to us, and for us to inform our users about them."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/dmca-policy"
            }
        }
    ]
};
wpRoutes['/platform'] = {
    "name": "wp__platform",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_platform_.html",
        "uk": "../wp-pages/pages/compiled/uk/_platform_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_platform_",
            "UK:landing_uk:_platform_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_platform_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_platform_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Human Capital Management Software | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Human Capital Management Software | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri provides the world's best human capital management software, helping businesses drive performance through unparalleled employee experience."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri provides the world's best human capital management software, helping businesses drive performance through unparalleled employee experience."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/platform"
            }
        }
    ]
};
wpRoutes['/partners'] = {
    "name": "wp__partners",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_partners_.html",
        "uk": "../wp-pages/pages/compiled/uk/_partners_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_partners_",
            "UK:landing_uk:_partners_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_partners_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_partners_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Integrations & Partners for A Better Hospitality Management System | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Integrations & Partners for A Better Hospitality Management System | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri makes it easy to connect with leading hospitality integrations like POS, Payroll, Talent, Restaurant Management Systems, and Assessments."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri makes it easy to connect with leading hospitality integrations like POS, Payroll, Talent, Restaurant Management Systems, and Assessments."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/partners"
            }
        }
    ]
};
wpRoutes['/carri-request-a-demo'] = {
    "name": "wp__carri_request_a_demo",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_carri-request-a-demo_.html",
        "uk": "../wp-pages/pages/compiled/uk/_carri-request-a-demo_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_carri-request-a-demo_",
            "UK:landing_uk:_carri-request-a-demo_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_carri-request-a-demo_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_carri-request-a-demo_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: Carri Request A Demo"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: Carri Request A Demo"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "So much more than a chatbot, Carri revolutionizes the candidate experience with mobile-driven conversational AI to acquire quality candidates, faster."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "So much more than a chatbot, Carri revolutionizes the candidate experience with mobile-driven conversational AI to acquire quality candidates, faster."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/carri-request-a-demo"
            }
        }
    ]
};
wpRoutes['/scheduling'] = {
    "name": "wp__scheduling",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_scheduling_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_scheduling_",
            "UK:landing_uk:_scheduling_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_scheduling_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "The Best Intelligent Employee Scheduling Software | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "The Best Intelligent Employee Scheduling Software | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Discover Harri's intelligent scheduling software for restaurants and hotels. Streamline labor management and enhance employee scheduling with Harri's all-in-one platform."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Discover Harri's intelligent scheduling software for restaurants and hotels. Streamline labor management and enhance employee scheduling with Harri's all-in-one platform."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/scheduling"
            }
        }
    ]
};
wpRoutes['/careers'] = {
    "name": "wp__careers",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_careers_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_careers_",
            "UK:landing_uk:_careers_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_careers_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Work with Us | Harri Careers"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Work with Us | Harri Careers"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Find your dream job at Harri. Join a team of career-minded professionals dedicated to supporting the hospitality industry."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Find your dream job at Harri. Join a team of career-minded professionals dedicated to supporting the hospitality industry."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20250506154556/assets/59c701c0456dc0838b3470ca7d9422e2.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/careers"
            }
        }
    ]
};
wpRoutes['/request-a-demo'] = {
    "name": "wp__request_a_demo",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_request-a-demo_.html",
        "uk": "../wp-pages/pages/compiled/uk/_request-a-demo_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_request-a-demo_",
            "UK:landing_uk:_request-a-demo_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_request-a-demo_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_request-a-demo_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Request a Demo: Hospitality Workforce Management Platform | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Request a Demo: Hospitality Workforce Management Platform | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Explore our all-in-one employee experience management systems for hospitality and learn how we help restaurants, hotels, and retailers revolutionize their HR and operations practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Explore our all-in-one employee experience management systems for hospitality and learn how we help restaurants, hotels, and retailers revolutionize their HR and operations practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/request-a-demo"
            }
        }
    ]
};
wpRoutes['/opt-in-thank-you'] = {
    "name": "wp__opt_in_thank_you",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_opt-in-thank-you_.html",
        "uk": "../wp-pages/pages/compiled/uk/_opt-in-thank-you_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_opt-in-thank-you_",
            "UK:landing_uk:_opt-in-thank-you_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_opt-in-thank-you_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_opt-in-thank-you_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/opt-in-thank-you"
            }
        }
    ]
};
wpRoutes['/intelligent-scheduling-for-the-workforce'] = {
    "name": "wp__intelligent_scheduling_for_the_workforce",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_intelligent-scheduling-for-the-workforce_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_intelligent-scheduling-for-the-workforce_",
            "UK:landing_uk:_intelligent-scheduling-for-the-workforce_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_intelligent-scheduling-for-the-workforce_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: COVID-19 Screening Technology for Schools & Universities"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: COVID-19 Screening Technology for Schools & Universities"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Implement COVID-19 symptoms screening technology for Schools & Universities to prevent the spread of the coronavirus on campus and in the classroom."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Implement COVID-19 symptoms screening technology for Schools & Universities to prevent the spread of the coronavirus on campus and in the classroom."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20250506154556/assets/d8972faf1a91d31b54ce635f7d3fdba7.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/intelligent-scheduling-for-the-workforce"
            }
        }
    ]
};
wpRoutes['/labor-compliance'] = {
    "name": "wp__labor_compliance",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_labor-compliance_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_labor-compliance_",
            "UK:landing_uk:_labor-compliance_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_labor-compliance_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: Hospitality Labor Compliance Software"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: Hospitality Labor Compliance Software"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri is the ultimate labor compliance software for restaurants, hotels, and all hospitality businesses. We make compliance easy, so you can focus on what you do best."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri is the ultimate labor compliance software for restaurants, hotels, and all hospitality businesses. We make compliance easy, so you can focus on what you do best."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/labor-compliance"
            }
        }
    ]
};
wpRoutes['/end-to-end-platform-for-coffee-concepts'] = {
    "name": "wp__end_to_end_platform_for_coffee_concepts",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_end-to-end-platform-for-coffee-concepts_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_end-to-end-platform-for-coffee-concepts_",
            "UK:landing_uk:_end-to-end-platform-for-coffee-concepts_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_end-to-end-platform-for-coffee-concepts_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: The First HCM Platform Built for Coffee Concepts"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: The First HCM Platform Built for Coffee Concepts"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri is helping Coffee Concepts to transform their HR and Operations practices in the new normal. Focused on the employee experience. Driven by data."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri is helping Coffee Concepts to transform their HR and Operations practices in the new normal. Focused on the employee experience. Driven by data."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/end-to-end-platform-for-coffee-concepts"
            }
        }
    ]
};
wpRoutes['/payroll'] = {
    "name": "wp__payroll",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_payroll_.html",
        "uk": "../wp-pages/pages/compiled/uk/_payroll_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_payroll_",
            "UK:landing_uk:_payroll_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_payroll_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_payroll_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/payroll"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "robots",
                "content": "noindex"
            }
        }
    ]
};
wpRoutes['/kickstart-hospitality-unite'] = {
    "name": "wp__kickstart_hospitality_unite",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_kickstart-hospitality-unite_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_kickstart-hospitality-unite_",
            "UK:landing_uk:_kickstart-hospitality-unite_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_kickstart-hospitality-unite_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/kickstart-hospitality-unite"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "robots",
                "content": "noindex"
            }
        }
    ]
};
wpRoutes['/privacy-hujobs'] = {
    "name": "wp__privacy_hujobs",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_privacy-hujobs_.html",
        "uk": "../wp-pages/pages/compiled/uk/_privacy-hujobs_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_privacy-hujobs_",
            "UK:landing_uk:_privacy-hujobs_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_privacy-hujobs_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_privacy-hujobs_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/privacy-hujobs"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "robots",
                "content": "noindex"
            }
        }
    ]
};
wpRoutes['/harri-insider'] = {
    "name": "wp__harri_insider",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_harri-insider_.html",
        "uk": "../wp-pages/pages/compiled/uk/_harri-insider_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_harri-insider_",
            "UK:landing_uk:_harri-insider_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_harri-insider_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_harri-insider_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri Insider: One Source of Hospitality Talent Management News"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri Insider: One Source of Hospitality Talent Management News"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Receive actionable insights, research, content, and news that cover all aspects of building, managing, and engaging your greatest resource. Your team."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Receive actionable insights, research, content, and news that cover all aspects of building, managing, and engaging your greatest resource. Your team."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20250506154556/assets/6b25b7d86569839c80b1f7e977029453.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/harri-insider"
            }
        }
    ]
};
wpRoutes['/care-sector'] = {
    "name": "wp__care_sector",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_care-sector_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_care-sector_",
            "UK:landing_uk:_care-sector_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_care-sector_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/care-sector"
            }
        }
    ]
};
wpRoutes['/carri-chat-and-apply'] = {
    "name": "wp__carri_chat_and_apply",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_carri-chat-and-apply_.html",
        "uk": "../wp-pages/pages/compiled/uk/_carri-chat-and-apply_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_carri-chat-and-apply_",
            "UK:landing_uk:_carri-chat-and-apply_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_carri-chat-and-apply_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_carri-chat-and-apply_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Carri - Conversational AI for Hospitality Powered by Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Carri - Conversational AI for Hospitality Powered by Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Revolutionize the hiring experience with Carri. Conversational AI built to streamline hiring and humanize the application journey."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Revolutionize the hiring experience with Carri. Conversational AI built to streamline hiring and humanize the application journey."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20250506154556/assets/4c83d3a8eaa3fb526a2580f3f86c8a46.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/carri-chat-and-apply"
            }
        }
    ]
};
wpRoutes['/grocery'] = {
    "name": "wp__grocery",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_grocery_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_grocery_",
            "UK:landing_uk:_grocery_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_grocery_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: Talent Acquisition Solutions for Grocery"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: Talent Acquisition Solutions for Grocery"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "End-to-End talent solutions built for grocery businesses to source, attract, and hire the best talent. Technology your teams will love."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "End-to-End talent solutions built for grocery businesses to source, attract, and hire the best talent. Technology your teams will love."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/grocery"
            }
        }
    ]
};
wpRoutes['/hospitality-unite'] = {
    "name": "wp__hospitality_unite",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_hospitality-unite_.html",
        "uk": "../wp-pages/pages/compiled/uk/_hospitality-unite_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_hospitality-unite_",
            "UK:landing_uk:_hospitality-unite_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_hospitality-unite_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_hospitality-unite_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: Find or post a job in retail, grocery, delivery, care sectors. Free of charge."
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: Find or post a job in retail, grocery, delivery, care sectors. Free of charge."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "We’re on a mission to help the millions of displaced workers in service industries find employment in retail, grocery, delivery, care, and many other sectors experiencing a surge in hiring. Join us, on this non-profit initiative."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "We’re on a mission to help the millions of displaced workers in service industries find employment in retail, grocery, delivery, care, and many other sectors experiencing a surge in hiring. Join us, on this non-profit initiative."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/hospitality-unite"
            }
        }
    ]
};
wpRoutes['/why-harri-platform'] = {
    "name": "wp__why_harri_platform",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_why-harri-platform_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_why-harri-platform_",
            "UK:landing_uk:_why-harri-platform_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_why-harri-platform_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "The Best HCM Platform for Restaurants and Hotels | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "The Best HCM Platform for Restaurants and Hotels | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri is the best human capital management (HCM) platform for restaurants and hotels. It helps businesses drive performance through employee performance."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri is the best human capital management (HCM) platform for restaurants and hotels. It helps businesses drive performance through employee performance."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/why-harri-platform"
            }
        }
    ]
};
wpRoutes['/partner-with-us'] = {
    "name": "wp__partner_with_us",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_partner-with-us_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_partner-with-us_",
            "UK:landing_uk:_partner-with-us_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_partner-with-us_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri: Partner With Us"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri: Partner With Us"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "You've built technology that's changed the world of hospitality for the better. We've got hundreds of clients eager to do their jobs more efficiently. Partner with Harri so we can shape the future of work in restaurants and hotels, together."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "You've built technology that's changed the world of hospitality for the better. We've got hundreds of clients eager to do their jobs more efficiently. Partner with Harri so we can shape the future of work in restaurants and hotels, together."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/partner-with-us"
            }
        }
    ]
};
wpRoutes['/thank-you'] = {
    "name": "wp__thank_you",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_thank-you_.html",
        "uk": "../wp-pages/pages/compiled/uk/_thank-you_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_thank-you_",
            "UK:landing_uk:_thank-you_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_thank-you_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_thank-you_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/thank-you"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "robots",
                "content": "noindex"
            }
        }
    ]
};
wpRoutes['/compliance'] = {
    "name": "wp__compliance",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_compliance_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_compliance_",
            "UK:landing_uk:_compliance_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_compliance_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Compliance Management System and Workforce Training Platform | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Compliance Management System and Workforce Training Platform | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri's compliance management system is the easiest way to ensure your team stays compliant and up to date with safety and training regulations."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri's compliance management system is the easiest way to ensure your team stays compliant and up to date with safety and training regulations."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20250506154556/assets/80917de40b906eb9d47d22f9849bf98d.svg"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/compliance"
            }
        }
    ]
};
wpRoutes['/insights-analytics'] = {
    "name": "wp__insights_analytics",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_insights-analytics_.html",
        "uk": "../wp-pages/pages/compiled/uk/_insights-analytics_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_insights-analytics_",
            "UK:landing_uk:_insights-analytics_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_insights-analytics_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_insights-analytics_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Transform Hospitality Data into Actionable Insights | Harri IQ Analytics"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Transform Hospitality Data into Actionable Insights | Harri IQ Analytics"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri IQ, the AI-driven analytics platform transforming data exploration in hospitality. Unlock insights, boost efficiency, and stay competitive. Request a demo today!"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri IQ, the AI-driven analytics platform transforming data exploration in hospitality. Unlock insights, boost efficiency, and stay competitive. Request a demo today!"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/insights-analytics"
            }
        }
    ]
};
wpRoutes['/post-hire/communications'] = {
    "name": "wp__post_hire_communications",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_post-hire_communications_.html",
        "uk": "../wp-pages/pages/compiled/uk/_post-hire_communications_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_post-hire_communications_",
            "UK:landing_uk:_post-hire_communications_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_post-hire_communications_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_post-hire_communications_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Streamline Employee Communication with Harri's Post-Hire Solutions | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Streamline Employee Communication with Harri's Post-Hire Solutions | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Boost post-hire communication with Harri's solutions. Improve engagement, streamline onboarding, and enhance retention. Discover more!"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Boost post-hire communication with Harri's solutions. Improve engagement, streamline onboarding, and enhance retention. Discover more!"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/post-hire/communications"
            }
        }
    ]
};
wpRoutes['/post-hire/time-attendance'] = {
    "name": "wp__post_hire_time_attendance",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_post-hire_time-attendance_.html",
        "uk": "../wp-pages/pages/compiled/uk/_post-hire_time-attendance_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_post-hire_time-attendance_",
            "UK:landing_uk:_post-hire_time-attendance_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_post-hire_time-attendance_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_post-hire_time-attendance_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Workplace Management: Timekeeping, Compliance, and Employee Engagement | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Workplace Management: Timekeeping, Compliance, and Employee Engagement | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri’s hospitality-focused attendance software monitors employee time accurately. Eliminate time theft, enhance compliance, and engage staff with secure biometric clock-ins."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri’s hospitality-focused attendance software monitors employee time accurately. Eliminate time theft, enhance compliance, and engage staff with secure biometric clock-ins."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/post-hire/time-attendance"
            }
        }
    ]
};
wpRoutes['/post-hire/scheduling'] = {
    "name": "wp__post_hire_scheduling",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_post-hire_scheduling_.html",
        "uk": "../wp-pages/pages/compiled/uk/_post-hire_scheduling_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_post-hire_scheduling_",
            "UK:landing_uk:_post-hire_scheduling_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_post-hire_scheduling_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_post-hire_scheduling_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Employee Scheduling Software for Efficient Workforce Management | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Employee Scheduling Software for Efficient Workforce Management | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Scheduling software for employee management. Simplify labor-compliant schedules, enhance operations, and boost productivity. Request a demo today."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Scheduling software for employee management. Simplify labor-compliant schedules, enhance operations, and boost productivity. Request a demo today."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/post-hire/scheduling"
            }
        }
    ]
};
wpRoutes['/post-hire'] = {
    "name": "wp__post_hire",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_post-hire_.html",
        "uk": "../wp-pages/pages/compiled/uk/_post-hire_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_post-hire_",
            "UK:landing_uk:_post-hire_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_post-hire_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_post-hire_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Workforce Management Technology Solutions & Software for Hospitality | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Workforce Management Technology Solutions & Software for Hospitality | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri's workforce management technology solutions and software streamline operations, boost productivity, and enhance employee engagement."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri's workforce management technology solutions and software streamline operations, boost productivity, and enhance employee engagement."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/post-hire"
            }
        }
    ]
};
wpRoutes['/pre-hire/onboarding'] = {
    "name": "wp__pre_hire_onboarding",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_pre-hire_onboarding_.html",
        "uk": "../wp-pages/pages/compiled/uk/_pre-hire_onboarding_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_pre-hire_onboarding_",
            "UK:landing_uk:_pre-hire_onboarding_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_pre-hire_onboarding_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_pre-hire_onboarding_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri - Employee Onboarding Software Built for Hospitality"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri - Employee Onboarding Software Built for Hospitality"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Hospitality onboarding has never been easier. Seamlessly onboard new hires with mobile-friendly forms, two-way document uploads for I9s and W4s, and more."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Hospitality onboarding has never been easier. Seamlessly onboard new hires with mobile-friendly forms, two-way document uploads for I9s and W4s, and more."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/pre-hire/onboarding"
            }
        }
    ]
};
wpRoutes['/pre-hire/applicant-tracking'] = {
    "name": "wp__pre_hire_applicant_tracking",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_pre-hire_applicant-tracking_.html",
        "uk": "../wp-pages/pages/compiled/uk/_pre-hire_applicant-tracking_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_pre-hire_applicant-tracking_",
            "UK:landing_uk:_pre-hire_applicant-tracking_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_pre-hire_applicant-tracking_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_pre-hire_applicant-tracking_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "The Applicant Tracking System for Restaurants, Hotels, and Hospitality | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "The Applicant Tracking System for Restaurants, Hotels, and Hospitality | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Our Applicant Tracking System (ATS) is mobile friendly and includes all features needed for efficient hiring for hospitality, restaurants & hotels."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Our Applicant Tracking System (ATS) is mobile friendly and includes all features needed for efficient hiring for hospitality, restaurants & hotels."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/pre-hire/applicant-tracking"
            }
        }
    ]
};
wpRoutes['/pre-hire/talent-attraction'] = {
    "name": "wp__pre_hire_talent_attraction",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_pre-hire_talent-attraction_.html",
        "uk": "../wp-pages/pages/compiled/uk/_pre-hire_talent-attraction_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_pre-hire_talent-attraction_",
            "UK:landing_uk:_pre-hire_talent-attraction_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_pre-hire_talent-attraction_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_pre-hire_talent-attraction_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "The Talent Attraction Platform for the Hospitality Industry | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "The Talent Attraction Platform for the Hospitality Industry | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri offers the most effective talent attraction tools for hospitality. Our solutions distribute open positions to millions of active job seekers in seconds."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri offers the most effective talent attraction tools for hospitality. Our solutions distribute open positions to millions of active job seekers in seconds."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/pre-hire/talent-attraction"
            }
        }
    ]
};
wpRoutes['/pre-hire'] = {
    "name": "wp__pre_hire",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_pre-hire_.html",
        "uk": "../wp-pages/pages/compiled/uk/_pre-hire_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_pre-hire_",
            "UK:landing_uk:_pre-hire_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_pre-hire_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_pre-hire_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Talent Acquisition Software | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Talent Acquisition Software | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Looking to hire your next candidate? Our talent acquisition software, ATS, and onboarding tools help hospitality businesses find and keep the industry's top talent."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Looking to hire your next candidate? Our talent acquisition software, ATS, and onboarding tools help hospitality businesses find and keep the industry's top talent."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/pre-hire"
            }
        }
    ]
};
wpRoutes['/privacy'] = {
    "name": "wp__privacy",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_privacy_.html",
        "uk": "../wp-pages/pages/compiled/uk/_privacy_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_privacy_",
            "UK:landing_uk:_privacy_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_privacy_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_privacy_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri Privacy Policy and Fair Processing Notice - US"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri Privacy Policy and Fair Processing Notice - US"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri's Privacy Policy outlines how we collect, use, and protect your personal data. Stay informed about your privacy rights and our practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri's Privacy Policy outlines how we collect, use, and protect your personal data. Stay informed about your privacy rights and our practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/privacy"
            }
        }
    ]
};
wpRoutes['/terms'] = {
    "name": "wp__terms",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_terms_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_terms_",
            "UK:landing_uk:_terms_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_terms_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": ""
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": ""
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/terms"
            }
        }
    ]
};
wpRoutes['/cookie-policy'] = {
    "name": "wp__cookie_policy",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_cookie-policy_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_cookie-policy_",
            "UK:landing_uk:_cookie-policy_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_cookie-policy_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri Website Cookie Policy - US"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri Website Cookie Policy - US"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Understand how Harri uses cookies to enhance your website experience. Read our cookie policy for details on data collection and user preferences."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Understand how Harri uses cookies to enhance your website experience. Read our cookie policy for details on data collection and user preferences."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/cookie-policy"
            }
        }
    ]
};
wpRoutes['/about-us'] = {
    "name": "wp__about_us",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_about-us_.html",
        "uk": "../wp-pages/pages/compiled/uk/_about-us_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_about-us_",
            "UK:landing_uk:_about-us_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_about-us_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_about-us_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "About Us: Hospitality Software for a Better Employee Experience"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "About Us: Hospitality Software for a Better Employee Experience"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Our hospitality software helps hotels and restaurants deliver a consistent, personalized experience to every guest or employee. Learn how we put service first."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Our hospitality software helps hotels and restaurants deliver a consistent, personalized experience to every guest or employee. Learn how we put service first."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20250506154556/assets/0b99233f05e1e7b1e5df87dbc5bdf0ad.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/about-us"
            }
        }
    ]
};
wpRoutes['/'] = {
    "name": "homepage",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/_.html",
        "uk": "../wp-pages/pages/compiled/uk/_.html"
    },
    "returnToOnLogin": true,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:_",
            "UK:landing_uk:_",
            "!UK:landing_default:global",
            "UK:landing_uk:global"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/_.html",
                    "uk": "../wp-pages/pages/compiled/uk/_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Harri - HCM & Workforce Management Technology for Service Industries"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Harri - HCM & Workforce Management Technology for Service Industries"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Harri’s powerful HCM technology helps enterprise restaurants, hotels, and retailers to transform their HR and Operations practices in the new normal."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Harri’s powerful HCM technology helps enterprise restaurants, hotels, and retailers to transform their HR and Operations practices in the new normal."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/harri-wp-plugin/prod/20250506154556/assets/e63c754feafa6f55a2fa011cf92c4cfa.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/"
            }
        }
    ]
};
wpRoutes['/request-a-demo-sandbox'] = {
    "name": "wp__request_a_demo_sandbox",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "uk": "../wp-pages/pages/compiled/uk/_request-a-demo-sandbox_.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "UK:landing_uk:_request-a-demo-sandbox_"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "uk": "../wp-pages/pages/compiled/uk/_request-a-demo-sandbox_.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {},
            "value": "Request a Demo: Hospitality Workforce Management Platform | Harri"
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title",
                "content": "Request a Demo: Hospitality Workforce Management Platform | Harri"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description",
                "content": "Explore our all-in-one employee experience management systems for hospitality and learn how we help restaurants, hotels, and retailers revolutionize their HR and operations practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description",
                "content": "Explore our all-in-one employee experience management systems for hospitality and learn how we help restaurants, hotels, and retailers revolutionize their HR and operations practices."
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.com/request-a-demo-sandbox"
            }
        }
    ]
};
wpRoutes['body-prefi'] = {
    "name": "wp_body_prefi",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/body-prefix.html",
        "uk": "../wp-pages/pages/compiled/uk/body-prefix.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:body-prefix",
            "UK:landing_uk:body-prefix"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/body-prefix.html",
                    "uk": "../wp-pages/pages/compiled/uk/body-prefix.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {}
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.combody-prefi"
            }
        }
    ]
};
wpRoutes['body-appendi'] = {
    "name": "wp_body_appendi",
    "controller": "LandingPageController",
    "templateUrl": "../modules/landing_pages/views/wp-landing-page.html",
    "controllerAs": "$ctrl",
    "wpDynamicTemplate": {
        "default": "../wp-pages/pages/compiled/default/body-appendix.html",
        "uk": "../wp-pages/pages/compiled/uk/body-appendix.html"
    },
    "returnToOnLogin": false,
    "route_styles": {
        "framework": "bootstrap_v4",
        "styles": [
            "!UK:landing_default:body-appendix",
            "UK:landing_uk:body-appendix"
        ]
    },
    "type": "backend-frontend",
    "data": [
        {
            "type": "data",
            "data": {
                "wpDynamicTemplate": {
                    "default": "../wp-pages/pages/compiled/default/body-appendix.html",
                    "uk": "../wp-pages/pages/compiled/uk/body-appendix.html"
                }
            },
            "id": "wpDynamicTemplate"
        },
        {
            "type": "data",
            "data": {
                "wpDynamicHeaderMenu": header
            },
            "id": "wpDynamicHeaderMenu"
        }
    ],
    "headTags": [
        {
            "tag": "title",
            "attributes": {}
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:title"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "name": "description"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:description"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:image",
                "content": "https://wordpress-content.harri.com/thumbnail/400_400.png"
            }
        },
        {
            "tag": "meta",
            "attributes": {
                "property": "og:site_name",
                "content": "Harri"
            }
        },
        {
            "tag": "link",
            "attributes": {
                "rel": "canonical",
                "href": "https://harri.combody-appendi"
            }
        }
    ]
};

try {
    wpRoutes['/']["route_dependencies"] = wpRoutes['/']["route_dependencies"] || [];
    wpRoutes['/']["route_dependencies"].push({
        type: 'chunk',
        loader: function () {
            return import('../hmodules/harri-main/harri-main.module.js');
        }
    });
    publicConfiguration['routes'] = _.extend(publicConfiguration['routes'], wpRoutes);
} catch (e) {
}

try {
    module.exports = wpRoutes;
} catch (e) {

}

